import React, { Component } from "react";

import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
} from "react-google-maps";

import "./LocationSearchModal.css";


/* =========================================================
   GOOGLE MAP
   נוצר פעם אחת בלבד ולא בכל render
========================================================= */

const AsyncMap = withScriptjs(
  withGoogleMap((props) => (

    <GoogleMap
      defaultZoom={props.zoom}

      defaultCenter={{
        lat: props.mapPosition.lat,
        lng: props.mapPosition.lng,
      }}

      options={{
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: true,
        zoomControl: true,
        gestureHandling: "greedy",
      }}
    >

      <Marker
        draggable={true}

        onDragEnd={props.onMarkerDragEnd}

        position={{
          lat: props.markerPosition.lat,
          lng: props.markerPosition.lng,
        }}

        title="ש.מ הובלות ומנופים"
      />

    </GoogleMap>

  ))
);


class MapPage extends Component {

  state = {
    height: 400,

    zoom: 15,

    /*
      מבצע דקל 14, פתח תקווה
      המיקום נשמר ניתן לגרירה ידנית במפה
    */
    mapPosition: {
      lat: 32.0957,
      lng: 34.8715,
    },

    markerPosition: {
      lat: 32.0957,
      lng: 34.8715,
    },

    currentTime: new Date(),

    isOpen: false,

    timeRemaining: "",
  };


  /* =========================================================
     START TIMER
  ========================================================= */

  componentDidMount() {

    this.updateBusinessStatus();

    this.statusTimer = setInterval(
      this.updateBusinessStatus,
      1000
    );

  }


  /* =========================================================
     STOP TIMER
  ========================================================= */

  componentWillUnmount() {

    clearInterval(this.statusTimer);

  }


  /* =========================================================
     BUSINESS STATUS + COUNTDOWN
  ========================================================= */

  updateBusinessStatus = () => {

    const now = new Date();

    const hours = now.getHours();

    const minutes = now.getMinutes();

    const seconds = now.getSeconds();


    const currentSeconds =
      hours * 3600 +
      minutes * 60 +
      seconds;


    const openingSeconds =
      7 * 3600;


    const closingSeconds =
      17 * 3600;


    const isOpen =
      currentSeconds >= openingSeconds &&
      currentSeconds < closingSeconds;


    let remainingSeconds;


    if (isOpen) {

      remainingSeconds =
        closingSeconds - currentSeconds;

    } else if (currentSeconds < openingSeconds) {

      remainingSeconds =
        openingSeconds - currentSeconds;

    } else {

      remainingSeconds =
        (24 * 3600 - currentSeconds) +
        openingSeconds;

    }


    const hoursLeft =
      Math.floor(
        remainingSeconds / 3600
      );


    const minutesLeft =
      Math.floor(
        (remainingSeconds % 3600) / 60
      );


    const secondsLeft =
      remainingSeconds % 60;


    const formattedTime =
      `${String(hoursLeft).padStart(2, "0")}:` +
      `${String(minutesLeft).padStart(2, "0")}:` +
      `${String(secondsLeft).padStart(2, "0")}`;


    this.setState({

      currentTime: now,

      isOpen,

      timeRemaining: formattedTime,

    });

  };


  /* =========================================================
     MARKER DRAG
  ========================================================= */

  onMarkerDragEnd = (event) => {

    const lat =
      event.latLng.lat();

    const lng =
      event.latLng.lng();


    this.setState({

      markerPosition: {
        lat,
        lng,
      },

    });

  };


  /* =========================================================
     RENDER
  ========================================================= */

  render() {

    return (

      <section
        className="location-section"
        dir="rtl"
      >

        <div className="location-container">


          {/* =====================================================
              OFFICE TITLE
          ===================================================== */}

          <div className="office-title">

            <span className="office-title-line"></span>

            <h2>
              משרדנו
            </h2>

            <p>
              ש.מ הובלות ומנופים
            </p>

            <span className="office-title-line"></span>

          </div>


          {/* =====================================================
              MAP CARD
          ===================================================== */}

          <div className="map-card">


            {/* =================================================
                TOP LINE
            ================================================= */}

            <div className="map-top-line">
              <span></span>
            </div>


            {/* =================================================
                MAP
            ================================================= */}

            <div className="map-inner">

              <AsyncMap

                googleMapURL={
                  "https://maps.googleapis.com/maps/api/js?key=AIzaSyC2H55uGYHc55B2L3CwQd2Jzijoj_isaU0&libraries=places"
                }

                loadingElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      background: "#f7fafc",
                    }}
                  />
                }

                containerElement={
                  <div
                    style={{
                      height: this.state.height,
                      width: "100%",
                    }}
                  />
                }

                mapElement={
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }

                zoom={this.state.zoom}

                mapPosition={this.state.mapPosition}

                markerPosition={this.state.markerPosition}

                onMarkerDragEnd={
                  this.onMarkerDragEnd
                }

              />

            </div>


            {/* =================================================
                INFORMATION
            ================================================= */}

            <div className="map-info">


              {/* =================================================
                  COMPANY NAME
              ================================================= */}

              <div className="map-info-item">

                <div>

                  <span className="map-icon">
                    🏢
                  </span>

                  <small>
                    שם החברה
                  </small>

                  <strong>
                    ש.מ הובלות ומנופים
                  </strong>

                </div>

              </div>


              {/* =================================================
                  ADDRESS
              ================================================= */}

              <div className="map-info-item">

                <div>

                  <span className="map-icon">
                    📍
                  </span>

                  <small>
                    כתובת
                  </small>

                  <strong>
                    מבצע דקל 14, פתח תקווה
                  </strong>

                </div>

              </div>


 



           

              {/* =================================================
                  BUSINESS HOURS
              ================================================= */}

              <div
                className="map-info-item business-hours"
                style={{
                  width: "100%",
                }}
              >

                <div
                  style={{
                    width: "100%",
                  }}
                >

                  <span className="map-icon">
                    🕒
                  </span>

                  <small>
                    שעות פעילות
                  </small>

                  <strong>
                    07:00 – 17:00
                  </strong>


                  {/* STATUS + COUNTDOWN */}

                  <div
                    className="business-status"
                  >

                    {/* OPEN / CLOSED */}

                    <span
                      className={
                        this.state.isOpen
                          ? "business-open"
                          : "business-closed"
                      }
                    >

                      <span
                        className="status-dot"
                      />

                      {this.state.isOpen
                        ? "פתוח עכשיו"
                        : "סגור עכשיו"}

                    </span>


                    {/* COUNTDOWN */}

                    <span
                      className="countdown"
                    >

                      {this.state.isOpen
                        ? `נסגר בעוד ${this.state.timeRemaining}`
                        : `נפתח בעוד ${this.state.timeRemaining}`}

                    </span>

                  </div>

                </div>

              </div>


            </div>

          </div>

        </div>

      </section>
    );
  }
}


export default MapPage;
